module.exports = __webpack_public_path__ + "static/media/Feather icon.27f533ea.jpeg";